import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twJoin } from 'tailwind-merge';
import { ArrowDownIcon } from '@systemeio/ui/icons';
interface SectionErrorListProps {
  error: string[];
}
export const SectionErrorsPathList = t0 => {
  const $ = _c(14);
  const {
    error
  } = t0;
  const {
    tICU
  } = useLocoTranslation();
  const [expanded, setExpanded] = useState(false);
  const hiddenCount = error.length - 3;
  const shouldShowButton = hiddenCount > 0;
  let t1;
  if ($[0] !== error) {
    t1 = error.slice(0, 3).map(_temp);
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== error.length || $[3] !== expanded || $[4] !== shouldShowButton || $[5] !== tICU) {
    t2 = shouldShowButton && <div onClick={() => setExpanded(!expanded)} className="flex cursor-pointer items-center gap-1"><ArrowDownIcon width={12} height={12} className={twJoin("stroke-danger shrink-0 transition-transform duration-300", expanded && "-rotate-90")} /><span className="text-danger text-base">{expanded ? tICU("dashboard.website.error_list.see_less", {
          count: error.length - 3
        }) : tICU("dashboard.website.error_list.see_more", {
          count: error.length - 3
        })}</span></div>;
    $[2] = error.length;
    $[3] = expanded;
    $[4] = shouldShowButton;
    $[5] = tICU;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== error || $[8] !== expanded) {
    t3 = expanded && error.slice(3).map(_temp2);
    $[7] = error;
    $[8] = expanded;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <div className="border-danger bg-danger/10 relative flex flex-wrap items-center gap-1 rounded-lg border p-2"><ul>{t1}{t2}{t3}</ul></div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
function _temp(item, index) {
  return <li className="text-text-primary [&_a]:text-brand-primary [&_a]:no-underline mb-1 last:mb-0" key={index} dangerouslySetInnerHTML={{
    __html: item
  }} />;
}
function _temp2(item_0, index_0) {
  return <li className="text-text-primary [&_a]:text-brand-primary [&_a]:no-underline mb-1 last:mb-0" key={index_0} dangerouslySetInnerHTML={{
    __html: item_0
  }} />;
}